export const dropDownData = [
    {
      text: "When the",
      code: ".show ",
    },
    {
      text: "class starts, dropdown appears. And ",
      code: ".btn-*",
    },
    {
      text: " to change button dark background colors. ",
    },
  ];
  
  export const dropDownList = [
    {
      btnText: "Ecommerce",
      btnColor: "secondary",
      dropClassName: "dropdown-block",
      items: [
        {
          item: "Product",
        },
        {
          item: "Product details",
        },
        {
          item: "Cart",
        },
      ],
    },
    {
      btnText: "Ui kits",
      btnColor: "warning",
      dropClassName: "dropdown-block",
      items: [
        {
          item: "Typography",
        },
        {
          item: "Avatars",
        },
        {
          item: "Grid",
        },
      ],
    },
    {
      btnText: "Error page",
      btnColor: "danger",
      dropClassName: "dropdown-block",
      items: [
        {
          item: "Error 400",
        },
        {
          item: "Error 403",
        },
        {
          item: "Error 500",
        },
      ],
    },
  ];
  
  export const roundedData = [
    {
      text: "When the",
      code: ".show ",
    },
    {
      text: "class starts, dropdown appears. And ",
      code: "rounded-pill",
    },
    {
      text: " to change rounded dropdowns.",
    },
  ];
  
  export const roundedList = [
    {
      btnText: "Success",
      btnColor: "success",
      dropClassName: "dropdown-block",
      toggleClassName: "rounded-pill",
      items: [
        {
          item: "Dark",
        },
        {
          item: "Light",
        },
        {
          item: "Lighter",
        },
      ],
    },
    {
      btnText: "Info",
      btnColor: "info",
      dropClassName: "dropdown-block",
      toggleClassName: "rounded-pill",
      items: [
        {
          item: "Dark",
        },
        {
          item: "Light",
        },
        {
          item: "Lighter",
        },
      ],
    },
    {
      btnText: "Warning",
      btnColor: "warning",
      dropClassName: "dropdown-block",
      toggleClassName: "rounded-pill",
      items: [
        {
          item: "Dark",
        },
        {
          item: "Light",
        },
        {
          item: "Lighter",
        },
      ],
    },
    {
      btnText: "Danger",
      btnColor: "danger",
      dropClassName: "dropdown-block",
      toggleClassName: "rounded-pill",
      items: [
        {
          item: "Dark",
        },
        {
          item: "Light",
        },
        {
          item: "Lighter",
        },
      ],
    },
  ];
  
  export const splitData = [
    {
      text: "When the",
      code: ".show ",
    },
    {
      text: "class starts, dropdown appears. And split the dropdown ",
      code: ".dropdown-toggle-split",
    },
  ];
  
  export const splitList = [
    {
      items: [{ item: "Animate" }, { item: "AOS animation" }],
      btnText: "Aniomation",
      btnColor: "secondary",
    },
    {
      items: [{ item: "Echarts" }, { item: "Apex chart" }],
      btnText: "Charts",
      btnColor: "success",
    },
    {
      items: [{ item: "Email app" }, { item: "Email compose" }],
      btnText: "Email",
      btnColor: "info",
    },
    {
      items: [{ item: "Flag icons" }, { item: "Fontawesome icons" }, { item: "Ico icons" }, { item: "Feather icons " }],
      btnText: "Icons",
      btnColor: "warning",
    },
    {
      items: [{ item: "Learning List" }, { item: "Detailed Course" }],
      btnText: "Learning",
      btnColor: "danger",
    },
  ];
  
  export const headingData = [
    {
      text: "Main heading and any sub-content in dropdown.",
    },
  ];
  
  export const withInputData = [
    {
      text: "Main heading and any sub-content in dropdown.",
    },
  ];
  
  export const darkData = [
    {
      code: ".dropdown-menu-dark ",
    },
    {
      text: "class through make dark mode.",
    },
  ];
  
  export const uniqueData = [
    {
      text: "Unique way to represent form dropdown and text dropdown.",
    },
  ];
  
  export const justifyData = [
    {
      text: "Use the",
      code: "(text-start/text-center/text-end)",
    },
    {
      text: " to change dropdown texts.",
    },
  ];
  
  export const justifyList = [
    {
      items: [{ item: "Chocolate" }, { item: "Ice-cream" }, { item: "Trophy" }],
      btnText: "Text-center",
      btnColor: "info",
      dropClassName: "dropdown-block text-center",
    },
    {
      items: [{ item: "I'm fine." }, { item: "ohh wow!" }, { item: "That's the good news! " }],
      btnText: "Text-right",
      btnColor: "primary",
      dropClassName: "dropdown-block text-end",
    },
  ];
  
  export const alignmentData = [
    {
      text: "Use the",
      code: "(text-start/text-center/text-end)",
    },
    {
      text: " to change dropdown texts.",
    },
  ];
  
  export const alignmentList = [
    {
      items: [{ item: "Good luck" }, { item: "Good job" }, { item: "Done!" }],
      btnText: "Success right",
      btnColor: "success",
      directions: "right",
      dropClassName: "dropdown-block text-end",
    },
    {
      items: [{ item: "It's important" }, { item: "Happy life " }, { item: "Another work" }],
      btnText: "Primary bottom",
      btnColor: "primary",
      directions: "down",
      dropClassName: "dropdown-block text-end",
    },
    {
      items: [{ item: "Threat" }, { item: "Dangerous" }, { item: "Alert" }],
      btnText: "Danget left",
      btnColor: "danger",
      directions: "left",
      dropClassName: "dropdown-block text-start",
    },
  ];
  
  export const helperData = [
    {
      text: "When the",
      code: ".show ",
    },
    {
      text: "class starts, dropdown appears.",
    },
  ];
  
  export const dividerData = [
    {
      text: "When the",
      code: ".show ",
    },
    {
      text: "class starts, dropdown appears ",
      code: ".dropdown-divider",
    },
    {
      text: " to change dropdown section.",
    },
  ];

  export const dividerSortData = [
    {
      items: [{ item: "Badminton" }, { item: "Tenis" }, { item: "Kho-Kho",divider: true},{item:"Separated link"}],
      btnText: "Sports",
      btnColor: "primary",
      dropClassName: "dropdown-block",
      toggleClassName: "rounded-pill",
      
    },
    {
      items: [{ item: "Orange" }, { item: "Red" }, { item: "Another work",divider: true },{item:"Separated link"}],
      btnText: "Colors",
      btnColor: "secondary",
      dropClassName: "dropdown-block",
      toggleClassName: "rounded-pill",
    },
  ];

  export const sizingData = [
    {
      text: "When the",
      code: ".show ",
    },
    {
      text: "class starts, dropdown appears. And ",
      code: "[.btn-lg/.btn-sm]",
    },
    {
      text: "class through button size changed.",
    },
  ];
  
  export const sizingList = [
    {
      items: [{ item: "Small button " }, { item: "Very small button " }, { item: "Extra small button",divider: true},{item:"Extra extra small"}],
      btnText: "Small button",
      btnColor: "dark",
      dropClassName: "dropdown-block",
      size:"sm",
      toggleClassName:"light",
    },
  ];
  